var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42857 15.2C3.42857 15.6 3.77143 16 4.28571 16H7.71429C8.22857 16 8.57143 15.6 8.57143 15.2V14.4H3.42857V15.2ZM6 0C2.65714 0 0 2.48 0 5.6C0 7.52 1.02857 9.2 2.57143 10.16V12C2.57143 12.4 2.91429 12.8 3.42857 12.8H8.57143C9.08571 12.8 9.42857 12.4 9.42857 12V10.16C10.9714 9.12 12 7.44 12 5.6C12 2.48 9.34286 0 6 0Z",
    fill: "#F9B234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBulb);
export default __webpack_public_path__ + "static/media/yellow-bulb.9df355094d21cee16389f05743348560.svg";
export { ForwardRef as ReactComponent };